import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { materialCalculatorApi } from '../../services/materialCalculator'
import MCProjectCreateForm from './components/MCProjectCreateForm'

export default function MCProjectCreatePage() {
  const navigate = useNavigate()
  const [rulesets, setRulesets] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => { materialCalculatorApi.listRulesets().then(setRulesets).catch(() => setRulesets([])) }, [])

  const createProject = async (payload) => {
    setLoading(true)
    try {
      const created = await materialCalculatorApi.createProject(payload)
      navigate(`/material-calculator/projects/${created.id}/wizard`)
    } finally {
      setLoading(false)
    }
  }

  return <MCProjectCreateForm rulesets={rulesets} onSubmit={createProject} loading={loading} />
}
